import Card from '../Card'
import { createUseStyles } from 'react-jss'
import { Colors } from '../../constants/colors'
import { PayRunListItemModel } from '../../redux/types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSnowflake } from '@fortawesome/free-solid-svg-icons'
import { formatMoney } from '../../utils/moneyHelper'
import Pagination from '../Pagination'

interface Props {
  paydayId: string
  payRunsOnPage: PayRunListItemModel[]
  pageIndex: number
  pageSize: number
  totalCount: number
  onPageChange: (pageIndex: number) => void 
}

const PayRunList = ({ paydayId, payRunsOnPage, pageIndex, pageSize, totalCount, onPageChange }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
        <div className={styles.cell}>
          <h6>User</h6>
        </div>
        <div className={styles.cell}>
          <h6>State</h6>
        </div>
        <div className={styles.cell}>
          <h6>Original salary</h6>
        </div>
        <div className={styles.cell}>
          <h6>Salary after deductions</h6>
        </div>
        <div className={styles.cell}>
          <h6>Deductions by employer</h6>
        </div>
        <div className={`${styles.cell} ${styles.icon}`}>
          <h6>Frozen</h6> 
        </div>
      </Card>
    )    
  }

  const renderListItems = () => {
    return payRunsOnPage?.map((item, index) => {
      return (
        <Link to={{pathname: `/paydays/${paydayId}/payruns/${item.id}`}} key={`payRun_${index}`}>
          <Card className={`${styles.container} card ${item.frozen ? styles.highlighted : ''}`}>
            <div className={styles.cell}>
            {`${item.userGivenName} ${item.userFamilyName}`}
            </div>
            <div className={styles.cell}>
              {item.state}
            </div>
            <div className={styles.cell}>
              {formatMoney(item.originalSalary)}
            </div>
            <div className={styles.cell}>
              {formatMoney(item.salaryAfterDeductions)}
            </div>
            <div className={styles.cell}>
              {formatMoney(item.deductedAmountByEmployer)}
            </div>
            <div className={`${styles.cell} ${styles.icon}`}>
              {item.frozen && 
                <FontAwesomeIcon
                    icon={faSnowflake}
                    color={Colors.euro_600}
                    title='Frozen'
                />}
            </div>
          </Card>
        </Link>
      )
    })
  }

  return (
    <div>
      {renderHeader()}
      {renderListItems()}
      <div className={styles.pagination}>
        <Pagination
          pageIndex={pageIndex}
          itemCount={totalCount}
          pageSize={pageSize}
          siblingCount={1}
          onPageChange={onPageChange}
        />
      </div>
    </div>   
  )
}

export default PayRunList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover
    }
  },
  header: {
    margin: '30px 0 20px 0',
  },
  cell: {
    flex: 1,
    padding: '0px 10px'
  },
  icon: {
    textAlign: 'center',  
  },
  highlighted: {
    backgroundColor: Colors.rubel5,
    color: Colors.darkGray4
  },
  pagination: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
})
